import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/register.css";
import Logo from "../images/logoss.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Toast from "../components/Toast";


// Email and Phone number regex validation
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phoneNumberRegex = /^[0-9]{10}$/;

const Register = () => {
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("info");

  const showToast = (message, type = "info") => {
    setToastMessage(message);
    setToastType(type);
  };


  const [value, setValue] = useState({
    username: "",
    email: "",
    phoneNumber: "",
    password: "",
    referralCode: "",
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refCode = params.get("ref");
    if (refCode) {
      setValue((prev) => ({ ...prev, referralCode: refCode }));
    }
  }, [location.search]);

  const onChangeHandler = (e) => {
    setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isUsernameValid = value.username.trim().length >= 3;
  const isPasswordValid = value.password.length >= 6;

  // Check if the form is valid
  const isFormValid =
    isUsernameValid &&
    emailRegex.test(value.email) &&
    phoneNumberRegex.test(value.phoneNumber) &&
    isPasswordValid;

  // Handle form submission
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const userData = { ...value };
      if (!userData.referralCode.trim()) {
        delete userData.referralCode;
      }

      const response = await register(userData);

      if (response.error) {
        setError(response.error);
        showToast(response.error, "error");
      } else if (response.status === "otp_sent") {
        showToast("Signup successful! Please verify your email.", "success");
       navigate(`/verify-account?email=${encodeURIComponent(response.email)}&alreadySent=true`);
      } else {
        showToast("Unexpected response from server.", "error");
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Registration failed";
      setError(msg);
      showToast(msg, "error");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-container">
       {toastMessage && (
        <Toast
          message={toastMessage}
          type={toastType}
          onClose={() => setToastMessage("")}
        />
      )}
      {/* Left side - background image */}
      <div className="login-left register-left">
        <div className="login-left-content">
          <h2>SubnetExpress</h2>
          <p>Start your journey with fast, reliable, and affordable digital services across Nigeria.</p>
        </div>
      </div>

      {/* Right side - register form */}
      <div className="login-right">
        <div className="login-box register-box">
            <img src={Logo} alt="Logo" className="login-logo" />
          <div className="logo-cont">
            <h1 className="register-title">Create Account</h1>
            <p className="register-subtitle">Enter your details to create an account.</p>

            <form onSubmit={onSubmitHandler} className="register-form">
              <div className="input-container input-cont-first" style={{ position: "relative" }}>
                <label>Username</label>
                <input
                  type="text"
                  name="username"
                  onChange={onChangeHandler}
                  required
                  className={!isUsernameValid && value.username ? "error" : ""}
                />
                {!isUsernameValid && value.username && (
                  <p className="error-input">Username must be at least 3 characters</p>
                )}
              </div>

              <div className="input-container" style={{ position: "relative" }}>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={value.email}
                  onChange={onChangeHandler}
                  required
                  className={!emailRegex.test(value.email) && value.email ? "error" : ""}
                />
                {!emailRegex.test(value.email) && value.email && (
                  <p className="error-input">Invalid Email Address</p>
                )}
              </div>

              <div className="input-container" style={{ position: "relative" }}>
                <label>Phone Number</label>
                <div className="phone-input-group">
                  <div className="phone-code">+234</div>
                  <input
                    type="text"
                    name="phoneNumber"
                    placeholder="700 000 000"
                    value={value.phoneNumber}
                    onChange={onChangeHandler}
                    required
                    maxLength="10"
                    pattern="[0-9]*"
                    className={!phoneNumberRegex.test(value.phoneNumber) && value.phoneNumber ? "error" : ""}
                  />
                </div>
                {!phoneNumberRegex.test(value.phoneNumber) && value.phoneNumber && (
                  <p className="error-input">Invalid Phone Number</p>
                )}
              </div>

              <div className="input-container">
                <label>Referral Code (Optional)</label>
                <input
                  type="text"
                  name="referralCode"
                  value={value.referralCode}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="input-container" style={{ position: "relative" }}>
                <label>Password</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={value.password}
                    onChange={onChangeHandler}
                    required
                    className={value.password && value.password.length < 6 ? "error" : ""}
                  />
                  <span onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                {value.password && value.password.length < 6 && (
                  <p className="error-input">Password must be at least 6 characters</p>
                )}
              </div>

              {error && <p className="error-text error-adj">{error}</p>}

              <button className="reg-btn" type="submit" disabled={!isFormValid || loading}>
                {loading ? "Registering..." : "Create Account"}
              </button>



              <p className="register-login-link">
                Already have an account? <Link to="/login">Sign in</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Register;
